
import { cn } from "@/lib/utils";

interface InvenioLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  color?: string;
  strokeWidth?: "thin" | "regular" | "thick";
  strokeColor?: string;
  hoverEffect?: boolean;
}

export const InvenioLogo = ({ 
  className, 
  size = "md", 
  color,
  strokeWidth = "regular",
  strokeColor,
  hoverEffect = false
}: InvenioLogoProps) => {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-10 h-10",
  };

  const strokeWidths = {
    thin: "1",
    regular: "1.5",
    thick: "2",
  };

  const baseClasses = cn(
    sizeClasses[size],
    "transition-colors duration-200",
    hoverEffect && "hover:text-primary/80",
    className
  );

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      fill="none" 
      className={baseClasses}
      style={{ color: color }}
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M10.02 8c-.695-.933-1.877-2.238-1.416-3.524C8.91 3.621 11.007 2 12 2s3.09 1.62 3.396 2.476c.461 1.286-.722 2.591-1.416 3.524M8 8h8m-8 5h8m-8.5 5h9m-7-10L7 22m7.5-14L17 22M5 22h14m0-14.5l2-.5m-2 3.5l2 .5M5 7.5L3 7m2 3.5L3 11" 
        stroke={strokeColor || "currentColor"}
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth={strokeWidths[strokeWidth]}
      />
    </svg>
  );
};

